import store from '@/store'
import _ from 'lodash'
import moment from 'moment'
import settingsAPI from '@/modules/settings/api/settings'
import misc from '@/services/misc'
import estimateLineItemsAPI from '@/modules/estimates/api/estimateLineItems'
import accountingAPI from '@/api/accounting';
import router from '@/router'

export default {
  handleAPIError(error) {
   if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data)
      console.log(error.response.status)
      console.log(error.response.headers)
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message)
    }
    alert(error + '\r\n\r\nOops, something went wrong \r\nPlease contact Westcap.')
    return null
  },
  buildHours (start = 0, stop = 10, increments = 1, display = 'hrs') {
    /*
    Creates an array of numbers, from start to stop, in increments of `increments`.
    Used when the user needs to pick a time value from a menu.
    Returns:
    {
      value: X,
      text: 'X'
    }
    */
    var arr = []
    var current = start
    while (current <= stop) {
      arr.push({ value: current, text: current + ' ' + display })
      current = current + increments
    }
    return arr
  },
  buildTimes (start = 0, stop = 24, increments = 5) {
    /* Builds an array of time increments, with each
    array object having the format:
    {
      value: HH:MM:SS,
      text: H:MM am/pm
    }
    This should allow you to use it in a wide range of applications, specifically
    in time menu pickers, for the Vuetify library.

    If any of the passed in variables are null, the default parameters will be:
    start: midnight
    stop: midnight (24 hours later)
    increments: 5

    These defaults should be ridiculous enough that it'll force you to add your own
    values when this function is called. The parameters to pass in must be 24 hour values (0 - 23)
    */

    start = parseInt(start)
    stop = parseInt(stop)
    increments = parseInt(increments)

    // First, verify that stop >= start
    if (start > stop) {
      return 'ERROR (misc.buildTimes): Stop is smaller than Start'
    }

    var times = []
    var dhr = ''
    var vhr = ''
    var ampm = 'am'

    for (var i = start; i <= stop; i++) {
      dhr = i
      vhr = i
      if (i < 10) {
        vhr = '0' + i
      }
      if (i > 11) {
        ampm = 'pm'
      }
      if (i > 12) {
        dhr = i - 12
      }
      // Now we set up all the increments, starting at the top of the hour
      for (var j = 0; j < 60; j += increments) {
        if (j < 10) {
          times.push({ value: vhr + ':0' + j + ':00', text: dhr + ':0' + j + ' ' + ampm })
        } else {
          times.push({ value: vhr + ':' + j + ':00', text: dhr + ':' + j + ' ' + ampm })
        }
      }
    }
    return times
  },
  replaceObject (arr, newObj) {
    // Replaces an object in an array
    let old = _.find(arr, function (o) { return o.id === newObj.id })

    let index = arr.indexOf(old);
    console.log(index)
    // arr.splice(index, 1)
    arr.splice(index, 1, newObj)
    return arr
  },
  removeObject (arr, obj) {
    // Will remove an object from an array
    let old = _.find(arr, function (o) { return o.id === obj.id })
    let index = arr.indexOf(old)
    arr.splice(index, 1)
    return arr
  },
  getLastItem (items) {
    const sorted = this.sortLineItems(items)
    return(sorted[sorted.length - 1])
  },
  sortLinkedList (items) {
    return this.sortLineItems(items)
  },
  sortLineItems (items) {
    /*
    Takes in an array of objects and returns a new array in sorted order
    The objects MUST have, at the minimum, a field called `comes_after` which
    points to another object in the array.
    */
    let arr = []
    let tmp = null
    // console.log('----- INSIDE SORT LINKED LIST --------')
    // console.log('Here is the full list for reference')
    // items.forEach(function (w) {
    //   console.log(w.id + ' ' + w.project_name + ' CA: ' + w.comes_after)
    // })
    for (let i = 0; i < items.length; i++) {
      // console.log('i iteration: ' + i)
      // The first item we want to start with is the item that comes_after null -- that's the first item
      if (i === 0) {
        tmp = _.find(items, function (d) { return d.comes_after === null })
      } else {
        // Otherwise, we simply find the item that comes after the tmp item (which was the previous item)
        tmp = tmp ? _.find(items, function (d) { return d.comes_after === tmp.id }) : null
        // if (tmp) {
        //   console.log(tmp.id + ' -- ' + tmp.project_name + ' CA: ' + tmp.comes_after)
        // } else {
        //   console.log('TMP is null?')
        // }
      }
      arr.push(tmp)
    }
    return arr
  },
  async sortItemDown (item, allItems, lineType) {
    /*
    Moves a singe line item DOWN in the order of line items.
    Takes care of PATCHing all the related linked list pointers for the related
    estimate line items

    The `lineType` variable will dictate which PATCH methods to call. The possible types
    should be one of the following:

      `estimate`
      `invoice`
    */
    const itemAfter = _.find(allItems, function (i) { return i.comes_after === item.id })
    const doubleAfter = _.find(allItems, function (i) { return i.comes_after === itemAfter.id })
    let newAllItems = null
    itemAfter.comes_after = item.comes_after
    item.comes_after = itemAfter.id
    if (doubleAfter) {
      doubleAfter.comes_after = item.id
    }

    let newItem = null
    let newAfter = null
    let newDoubleAfter = null

    // Here we PATCH the line items, based on the lineType passed in
    switch (lineType) {
      case 'estimate':
        newItem = await estimateLineItemsAPI.updateEstimateLineItem(item)
        newAllItems = misc.replaceObject(allItems, newItem)
        newAfter = await estimateLineItemsAPI.updateEstimateLineItem(itemAfter)
        newAllItems = misc.replaceObject(allItems, newAfter)
        if (doubleAfter) {
          newDoubleAfter = await estimateLineItemsAPI.updateEstimateLineItem(doubleAfter)
          newAllItems = misc.replaceObject(allItems, newDoubleAfter)
        }
        break
      case 'invoice':
        newItem = await accountingAPI.updateInvoiceLineItem(item)
        newAllItems = misc.replaceObject(allItems, newItem)
        newAfter = await accountingAPI.updateInvoiceLineItem(itemAfter)
        newAllItems = misc.replaceObject(allItems, newAfter)
        if (doubleAfter) {
          newDoubleAfter = await accountingAPI.updateInvoiceLineItem(doubleAfter)
          newAllItems = misc.replaceObject(allItems, newDoubleAfter)
        }
        break
    }
    return newAllItems
  },
  async sortItemUp (item, allItems, lineType) {
    /*
    Moves a singe line item UP in the order of line items.
    Takes care of PATCHing all the related linked list pointers for the related
    estimate line items

    The `lineType` variable will dictate which PATCH methods to call. The possible types
    should be one of the following:
    
      `estimate`
      `invoice`
    */

    // itemAfter is the one AFTER the passed in `item` -- it may not exist (then `item` is the last item in the list)
    const itemAfter = _.find(allItems, function (i) { return i.comes_after === item.id })
    // itemBefore is the one BEFORE the pass in `item`
    const itemBefore = _.find(allItems, function (i) { return i.id === item.comes_after })
    let newAllItems = null

    item.comes_after = itemBefore.comes_after
    itemBefore.comes_after = item.id
    // This may be at the end of the list, so there may not be an itemAfter
    if (itemAfter) {
      itemAfter.comes_after = itemBefore.id
    }

    let newBefore = null
    let newItem = null
    let newAfter = null

    switch (lineType) {
      case 'estimate':
        newBefore = await estimateLineItemsAPI.updateEstimateLineItem(itemBefore)
        newAllItems = misc.replaceObject(allItems, newBefore)
        newItem = await estimateLineItemsAPI.updateEstimateLineItem(item)
        newAllItems = misc.replaceObject(allItems, newItem)

        if (itemAfter) {
          newAfter = await estimateLineItemsAPI.updateEstimateLineItem(itemAfter)
          newAllItems = misc.replaceObject(allItems, newAfter)
        }
        break
      case 'invoice':
        newBefore = await accountingAPI.updateInvoiceLineItem(itemBefore)
        newAllItems = misc.replaceObject(allItems, newBefore)
        newItem = await accountingAPI.updateInvoiceLineItem(item)
        newAllItems = misc.replaceObject(allItems, newItem)

        if (itemAfter) {
          newAfter = await accountingAPI.updateInvoiceLineItem(itemAfter)
          newAllItems = misc.replaceObject(allItems, newAfter)
        }
        break
    }
    return newAllItems
  },
  async deleteSortedItem (item, allItems, lineType) {
    /*
    Removes and deletes a singe line item from the ordered line items.
    Takes care of PATCHing all the related linked list pointers for the related
    estimate line items

    The `lineType` variable will dictate which PATCH methods to call. The possible types
    should be one of the following:
    
      `estimate`
      `invoice`
    */
    // itemAfter is the one AFTER the passed in `item` -- it may not exist (then `item` is the last item in the list)
    let itemAfter = _.find(allItems, function (i) { return i.comes_after === item.id })
    // itemBefore is the one BEFORE the pass in `item`
    // let itemBefore = _.find(allItems, function (i) { return i.id === item.comes_after })
    let newAllItems = allItems

    if (itemAfter) {
      if (item.comes_after) {
        itemAfter.comes_after = item.comes_after
      } else {
        itemAfter.comes_after = null
      }
    }

    // Remove the reference from the item being deleted
    item.comes_after = null
    newAllItems = misc.removeObject(newAllItems, item)

    let newAfter = null

    switch (lineType) {
      case 'invoice':
        await accountingAPI.deleteLineItem(item.id)
        if (itemAfter) {
          newAfter = await accountingAPI.updateInvoiceLineItem(itemAfter)
          newAllItems = this.replaceObject(newAllItems, newAfter)
        }
        break
      case 'estimate':
        await estimateLineItemsAPI.deleteLineItem(item.id)
        if (itemAfter) {
          newAfter = await estimateLineItemsAPI.updateEstimateLineItem(itemAfter)
          newAllItems = this.replaceObject(newAllItems, newAfter)
        }
        break
    }

    return newAllItems
  },
  getPaddedNumber (num) {
    // num = the number to pad
    // Will return the `num` padded so it is always 4 digits long
    // Now to tack on the invoice counter -- padded.
    num = num < 10 ? '000' + num : num
    num = num < 100 && num > 9 ? '00' + num : num
    num = num < 1000 && num > 99 ? '0' + num : num
    return num
  },
  openInNewTab (routeObj) {
    // send in a route object, such as: { name: 'SomeRouteName', params: { p1: XYZ } }
    // and it will open that location in a new tab
    const link = document.createElement('a')
    const newTabURL = router.resolve(routeObj)
    link.target = '_blank'
    link.href = newTabURL.href
    link.click()

  },
  downloadAsSpreadsheet(headers, rows, filename) {
    const XLSX = require('xlsx')
    const data = headers && headers.length > 0 ? [headers, ...rows] : rows
    const ws = XLSX.utils.aoa_to_sheet(data)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
    XLSX.writeFile(wb, `${filename}.xlsx`)
  },
  async createActionTracker (obj) {
    /*
      Object passed in requires two fields, like so:
      {
        description: 'action taken',
        object: object.id <-- This can change based on the scenario. Could be work_order, could be invoice, etc
      }
    */
    obj['action_date'] = moment().format('YYYY-MM-DD').toString()
    obj['taken_by'] = store.state.auth.profile.id
    return await settingsAPI.createActionTracker(obj)
  }
}
